<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-row>
          <b-col md="4" class="my-1">
            <b-navbar-nav>
              <b-button @click="goBack" size="sm" variant="outline-secondary">
                <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
              </b-button>
            </b-navbar-nav>
            <h5 class="mt-1 mr-2">
              {{ $route.name }}
            </h5>
          </b-col>
          <b-col md="2">
            <h5>
              <small v-if="isLoading == false">{{ totalData }} Entries</small>
            </h5>
          </b-col>
          <b-col md="4">
            <b-button
              class="pull-right ml-1 mt-1"
              :variant="
                Filter.reviewedFilter ||
                Filter.BilledRemark ||
                Filter.MblNoFilter ||
                Filter.HblNoFilter ||
                Filter.ContainerNoFilter ||
                Filter.JobNoFilter ||
                Filter.remarkFilter ||
                Filter.additionalTaskFilter ||
                Filter.expenseFilter ||
                Filter.menifestationFilter ||
                Filter.SlineFilter ||
                Filter.finalBillingStatusFilter ||
                Filter.billingTypeFilter ||
                Filter.clearStatusFilter ||
                Filter.statusFilter ||
                Filter.clientFilter ||
                Filter.slineIdFilter ||
                Filter.commonFilter ||
                Filter.createdByFilter ||
                Filter.clearedByFilter ||
                Filter.branchFilter ||
                Filter.createdAtRange.startDate ||
                Filter.createdAtRange.endDate
                  ? 'outline-danger'
                  : 'outline-primary'
              "
              :class="' ml-4' + visible ? null : 'collapsed'"
              :aria-expanded="visible ? 'true' : 'false'"
              aria-controls="collapse-4"
              @click="visible = !visible"
              style="font-size: 0.675rem"
              >{{
                Filter.reviewedFilter ||
                Filter.BilledRemark ||
                Filter.MblNoFilter ||
                Filter.HblNoFilter ||
                Filter.ContainerNoFilter ||
                Filter.JobNoFilter ||
                Filter.remarkFilter ||
                Filter.additionalTaskFilter ||
                Filter.expenseFilter ||
                Filter.menifestationFilter ||
                Filter.SlineFilter ||
                Filter.finalBillingStatusFilter ||
                Filter.billingTypeFilter ||
                Filter.clearStatusFilter ||
                Filter.statusFilter ||
                Filter.clientFilter ||
                Filter.slineIdFilter ||
                Filter.commonFilter ||
                Filter.createdByFilter ||
                Filter.clearedByFilter ||
                Filter.branchFilter ||
                Filter.createdAtRange.startDate ||
                Filter.createdAtRange.endDate
                  ? "Filter ON"
                  : "Filter OFF"
              }}</b-button
            >
            <b-button
              class="pull-right ml-1 mt-1"
              v-if="getLockPanel.length > 0"
              :disabled="ExcelBtnName != 'Export As Excel' ? true : false"
              @click="getReports('getLockPanel', 'Export As Excel')"
              size="sm"
              variant="warning"
              style="font-size: 0.675rem"
            >
              {{ ExcelBtnName }}
              <b-spinner
                v-if="ExcelBtnName != 'Export As Excel'"
                small
                label="Small Spinner"
              ></b-spinner
            ></b-button>
          </b-col>

          <b-col cols="12">
            <div>
              <b-pagination
                limit="25"
                align="center"
                v-model="pagination.currentPage"
                :per-page="pagination.perPage"
                :total-rows="totalData"
                @change="onPageChange($event)"
              ></b-pagination>
            </div>
          </b-col>
          <b-col cols="6">
            <input
              type="checkbox"
              @click="SelectAll(getLockPanel)"
              v-model="isCheckAll"
            />
            <label>Select / Deselect All Count({{ this.AllModule_ids.length }})</label>
            <b-button
              v-if="AllModule_ids.length > 0"
              size="sm"
              @click="ProceedReview"
              variant="outline-primary"
              >Proceed Review</b-button
            >
          </b-col>
        </b-row>
        <div v-if="visible">
          <b-card>
            <b-collapse v-model="visible" id="collapse-2">
              <b-row>
                <!-- <b-col md="3">
                  <label>Status</label>

                  <model-list-select
                    :list="StatusList"
                    v-model="Filter.statusFilter"
                    option-value="DVal"
                    option-text="DText"
                    placeholder="Select"
                    @input="getLockPanelDash('Normal', '0', '0', '1', '1')"
                  ></model-list-select>
                </b-col> -->
                <b-col md="3">
                  <label>Date</label>
                  <date-range-picker
                    :always-show-calendars="showCal"
                    v-model="Filter.createdAtRange"
                    :startDate="startDate"
                    :endDate="endDate"
                    :locale-data="locale"
                    :disabled="Filter.DFlag ? true : false"
                    @update="getLockPanelDash('Normal', '0', '0', '1', '1')"
                  ></date-range-picker>
                </b-col>
                <b-col md="3">
                  <label>Reviewed</label>
                  <model-list-select
                    :list="paymentType"
                    v-model="Filter.reviewedFilter"
                    option-value="pTypeVal"
                    option-text="pTypeText"
                    placeholder="Select Reviewed"
                    @input="getLockPanelDash('Normal', '0', '0', '1', '1')"
                  ></model-list-select>
                </b-col>

                <b-col md="3">
                  <label>Sline</label>
                  <model-list-select
                    :list="paymentType"
                    v-model="Filter.SlineFilter"
                    option-value="pTypeVal"
                    option-text="pTypeText"
                    placeholder="Select Payment Sline"
                    @input="getLockPanelDash('Normal', '0', '0', '1', '1')"
                  ></model-list-select>
                </b-col>
                <b-col md="3">
                  <label>Expense</label>
                  <model-list-select
                    :list="paymentType"
                    v-model="Filter.expenseFilter"
                    option-value="pTypeVal"
                    option-text="pTypeText"
                    placeholder="Select Expense Sline"
                    @input="getLockPanelDash('Normal', '0', '0', '1', '1')"
                  ></model-list-select>
                </b-col>
                <b-col md="3">
                  <label>Additional Task</label>
                  <model-list-select
                    :list="paymentType"
                    v-model="Filter.additionalTaskFilter"
                    option-value="pTypeVal"
                    option-text="pTypeText"
                    placeholder="Select Additional Task"
                    @input="getLockPanelDash('Normal', '0', '0', '1', '1')"
                  ></model-list-select>
                </b-col>
                <b-col md="3">
                  <label>Clear Status</label>
                  <model-list-select
                    :list="paymentClearType"
                    v-model="Filter.clearStatusFilter"
                    option-value="inv"
                    option-text="int"
                    placeholder="Select Clear Status"
                    @input="getLockPanelDash('Normal', '0', '0', '1', '1')"
                  ></model-list-select>
                </b-col>
                <b-col md="3">
                  <label>Billing Status</label>

                  <model-list-select
                    :list="BillingStatusList"
                    v-model="Filter.finalBillingStatusFilter"
                    option-value="inv"
                    option-text="int"
                    placeholder="Select Billing Status"
                    @input="getLockPanelDash('Normal', '0', '0', '1', '1')"
                  ></model-list-select>
                </b-col>
                <b-col md="3">
                  <label>Billing Type</label>
                  <model-list-select
                    :list="BillingTypeStatusList"
                    v-model="billingTypeFilter"
                    option-value="inv"
                    option-text="int"
                    placeholder="Select Billing Type"
                    @input="getLockPanelDash('Normal', '0', '0', '1', '1')"
                  ></model-list-select>
                </b-col>
                <b-col md="3">
                  <label>Shipping Line</label>
                  <model-list-select
                    :list="$store.getters['common/getAllShippingLineList']"
                    v-model="Filter.slineIdFilter"
                    option-value="shippingId"
                    option-text="ShippingLine"
                    placeholder="Select Shipping Line"
                    @input="getLockPanelDash('Normal', '0', '0', '1', '1')"
                  ></model-list-select>
                </b-col>
                <b-col md="3">
                  <label>Client</label>
                  <model-list-select
                    :list="$store.getters['common/getAllClientList']"
                    id="clientFilter"
                    v-model="Filter.clientFilter"
                    option-value="clientId"
                    option-text="ClientName"
                    placeholder="Select Client Name"
                    @input="getLockPanelDash('Normal', '0', '0', '1', '1')"
                  ></model-list-select>
                </b-col>
                <b-col md="3">
                  <label>Branch</label>
                  <model-list-select
                    :list="$store.getters['common/getAllBranchList']"
                    id="branchfilter"
                    v-model="Filter.branchFilter"
                    option-value="pickupId"
                    option-text="pickupLocation"
                    placeholder="All"
                    @input="getLockPanelDash('Normal', '0', '0', '1', '1')"
                  ></model-list-select>
                </b-col>
                <b-col md="3">
                  <label>MBL No Filter</label>
                  <b-form-input
                    type="text"
                    :formatter="capitalizeAll"
                    placeholder="Search MBL No Filter"
                    id="MblNoFilter"
                    name="MblNoFilter"
                    autocomplete="off"
                    v-model="Filter.MblNoFilter"
                    @input="getLockPanelDash('Normal', '0', '0', '1', '1')"
                  ></b-form-input>
                </b-col>
                <b-col md="3">
                  <label>HBL No Filter</label>
                  <b-form-input
                    type="text"
                    :formatter="capitalizeAll"
                    placeholder="Search HBL No Filter"
                    id="HblNoFilter"
                    name="HblNoFilter"
                    autocomplete="off"
                    v-model="Filter.HblNoFilter"
                    @input="getLockPanelDash('Normal', '0', '0', '1', '1')"
                  ></b-form-input>
                </b-col>
                <b-col md="3">
                  <label>Container No Filter</label>
                  <b-form-input
                    type="text"
                    :formatter="capitalizeAll"
                    placeholder="Search Container No Filter"
                    id="ContainerNoFilter"
                    name="ContainerNoFilter"
                    autocomplete="off"
                    v-model="Filter.ContainerNoFilter"
                    @input="getLockPanelDash('Normal', '0', '0', '1', '1')"
                  ></b-form-input>
                </b-col>
                <b-col md="3">
                  <label>JOB No Filter</label>
                  <b-form-input
                    type="text"
                    :formatter="capitalizeAll"
                    placeholder="Search JOB No Filter"
                    id="JobNoFilter"
                    name="JobNoFilter"
                    autocomplete="off"
                    v-model="Filter.JobNoFilter"
                    @input="getLockPanelDash('Normal', '0', '0', '1', '1')"
                  ></b-form-input>
                </b-col>
                <b-col md="3">
                  <label>Common Filter</label>
                  <b-form-input
                    type="text"
                    :formatter="capitalizeAll"
                    placeholder="Search Common Filter"
                    id="commonFilter"
                    name="commonFilter"
                    autocomplete="off"
                    v-model="Filter.commonFilter"
                    @input="getLockPanelDash('Normal', '0', '0', '1', '1')"
                  ></b-form-input>
                </b-col>
                <b-col md="3">
                  <label>Remark Filter</label>
                  <b-form-input
                    type="text"
                    :formatter="capitalizeAll"
                    placeholder="Search Common Filter"
                    id="remarkFilter"
                    name="remarkFilter"
                    autocomplete="off"
                    v-model="Filter.remarkFilter"
                    @input="getLockPanelDash('Normal', '0', '0', '1', '1')"
                  ></b-form-input>
                </b-col>
                <b-col md="3">
                  <label>
                    <b> Created User </b>
                  </label>
                  <model-list-select
                    :list="$store.getters['common/getAllUserList']"
                    id="createdByFilter"
                    @input="getLockPanelDash('Normal', '0', '0', '1', '1')"
                    v-model="Filter.createdByFilter"
                    option-value="userId"
                    option-text="employeeName"
                    placeholder="Select Created User"
                  ></model-list-select>
                </b-col>
                <b-col md="3">
                  <label>
                    <b> Cleared By User </b>
                  </label>
                  <model-list-select
                    :list="$store.getters['common/getAllUserList']"
                    id="clearedByFilter"
                    @input="getLockPanelDash('Normal', '0', '0', '1', '1')"
                    v-model="Filter.clearedByFilter"
                    option-value="userId"
                    option-text="employeeName"
                    placeholder="Select Cleared User"
                  ></model-list-select>
                </b-col>
                <b-col md="3">
                  <label>
                    <b>Reviewed By User </b>
                  </label>
                  <model-list-select
                    :list="$store.getters['common/getAllUserList']"
                    id="reviewedByFilter"
                    @input="getLockPanelDash('Normal', '0', '0', '1', '1')"
                    v-model="Filter.reviewedByFilter"
                    option-value="userId"
                    option-text="employeeName"
                    placeholder="Select Reviewed User"
                  ></model-list-select>
                </b-col>
                <b-col md="3">
                  <label>Remark:</label>
                  <model-list-select
                    class="ml-3"
                    :list="billedStatusList"
                    v-model="Filter.BilledRemark"
                    option-value="value"
                    option-text="text"
                    placeholder="Select Remark"
                    @input="getLockPanelDash('Normal', '0', '0', '1', '1')"
                  >
                  </model-list-select>
                </b-col>
                <b-col md="12" class="mt-2">
                  <b-button
                    size="sm"
                    style="margin-left: auto"
                    class="ml-1 pull-right"
                    @click="clearFilter"
                    variant="outline-danger"
                    >Reset</b-button
                  >
                </b-col>
              </b-row>
            </b-collapse>
          </b-card>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="table-responsive tableMain gutr">
              <b-table
                show-empty
                stacked="md"
                responsive
                :items="getLockPanel"
                :fields="LockDashFields"
                primary-key="id_email_section"
                :per-page="pagination.perPage"
                :filter="filter"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :sort-direction="sortDirection"
                @filtered="onFiltered"
                class="position-relative"
              >
                <!-- Default Row Data -->
                <template slot="SN" slot-scope="row0">
                  <input
                    v-if="row0.item.isActive == '1' && row0.item.is_reviewed == 0"
                    type="checkbox"
                    v-bind:value="row0.item.allModuleId"
                    v-bind:id="row0.item.extrapayment_id"
                    v-model="AllModule_ids"
                    @change="updateSelectAll($event, row0.item)"
                  />
                  <span>
                    {{
                      row0.index + 1 + (pagination.currentPage - 1) * pagination.perPage
                    }}
                  </span>
                </template>

                <template slot="JobNo" slot-scope="row1">
                  <strong
                    @click="row1.toggleDetails"
                    class="mr-2"
                    size="sm"
                    style="font-size: 0.675rem"
                    variant="outline-info"
                  >
                    {{ row1.item.JobNo }}
                    <span v-if="row1.detailsShowing">
                      &#9660;
                      <!-- Down arrow -->
                    </span>
                    <span v-else>
                      &#9654;
                      <!-- Right arrow -->
                    </span> </strong
                  ><br />
                  <strong>Job Date:</strong> {{ row1.item.JobDate }}<br />
                  <strong>Client Name:</strong> {{ row1.item.ClientName }}<br />
                  <strong>Raised From:</strong> {{ row1.item.RaisedFrom }}<br />
                  <strong>Raised By:</strong> {{ row1.item.RaisedBy }}<br />
                  <b-button
                          v-if="$sessionsStorage.get('is_Mobile') != 'port'"
                          size="sm"
                          class="mt-2"
                          style="font-size: 0.675rem"
                          @click="showDocModal(row1.item)"
                          variant="outline-info"
                        >
                          Summary & Documents
                        </b-button>
                        <InvExpSummary
                          v-if="row1.item.allModuleId"
                          :PMC_title="'Inv Exp Summary Job No - ' + row1.item.JobNo"
                          :PMC_JOBID="row1.item.allModuleId"
                          :PMC_JobNo="row1.item.JobNo"
                          :PMC_JobDate="row1.item.JobDate"
                          :PMC_JobType="row1.item.JobType"
                          :PMC_AgentType="''"
                          :PMC_Client="row1.item.ClientName"
                          :PMC_Sline="row1.item.ShippingLine"
                        />
                        <ContainerSummary
                          v-if="row1.item.allModuleId"
                          :PMC_title="'Container Summary Job No - ' + row1.item.JobNo"
                          :PMC_JOBID="row1.item.allModuleId"
                          :PMC_JobNo="row1.item.JobNo"
                          :PMC_JobDate="row1.item.JobDate"
                          :PMC_JobType="row1.item.JobType"
                          :PMC_AgentType="''"
                          :PMC_Client="row1.item.ClientName"
                          :PMC_Sline="row1.item.ShippingLine"
                        />
                        <JobWisePaymentsDetails
                  v-if="row1.item.allModuleId"
                  :allModuleId="Number(row1.item.allModuleId)"
                  :JobNo="row1.item.JOBNO"
                  />
                </template>

                <!-- <template slot="ClientName" slot-scope="row1">
                  {{ row1.item.ClientName }}
                </template> -->

                <template slot="EmailRemark" slot-scope="row1">
                  <b-button
                    style="font-size: 0.675rem"
                    v-if="row1.item.email_contents"
                    size="sm"
                    text="View Mult-Billing"
                    class="m-2"
                    variant="outline-info"
                    @click="
                      showextra_paymentModal(
                        row1.item.allModuleId,
                        row1.item.email_contents,
                        row1.item.doc_link,
                        row1.item,
                        row1.item.JobNo
                      )
                    "
                    ><b v-if="row1.item.is_additional_task == 1">Additional Task</b
                    ><b v-else-if="row1.item.is_expense == 1">Expense Task</b
                    ><b v-else-if="row1.item.is_menifestation == 1">Manifestation Task</b
                    ><b v-else-if="row1.item.is_slinepayment == 1"
                      >Sline Payment Task</b
                    ></b-button
                  >
                  <!-- <span v-html="row1.item.email_contents">{{
                          row1.item.email_contents
                        }}</span> -->
                  <br />{{ "Remarks : " + row1.item.EmailRemark }}
                </template>

                <template slot="CreatedDate" slot-scope="row1">
                  <strong>Created By:</strong> {{ row1.item.CreatedByUser }}<br />
                  <strong>Created Date:</strong> {{ row1.item.CreatedDate }}<br />
                  <strong>Cleared By:</strong> {{ row1.item.ClearedByUser }}<br />
                  <strong>Cleared Date:</strong> {{ row1.item.UpdatedDate }}<br />

                  <strong>Ass Close Reason:</strong
                  ><span v-html="row1.item.JobCloseReason">{{
                    row1.item.JobCloseReason
                  }}</span>
                </template>
                <template slot="FirstUnlockUser" slot-scope="row1">
                  <strong>First Unlock Reason:</strong>
                  {{ row1.item.FirstUnlockReason }}<br />
                  <strong>First Unlock User:</strong> {{ row1.item.FirstUnlockUser
                  }}<br />
                  <strong>First Unlock Date:</strong> {{ row1.item.FirstUnlockDate
                  }}<br />
                  <strong>Reviewed User:</strong> {{ row1.item.ReviewedUser }}<br />
                  <strong>Reviewed Date:</strong> {{ row1.item.ReviewedDate }}<br />
                  <strong>Reviewed Status:</strong> {{ row1.item.ReviewedStatus }}<br />
                  <strong>Billed Remark:</strong> {{ row1.item.BilledRemark }}<br />
                </template>

                <!-- Collapsible Row Details -->
                <template slot="row-details" slot-scope="row1">
                  <b-card>
                    <b-row>
                      <b-col>
                        <strong>Job No:</strong> {{ row1.item.JobNo }}<br />
                        <strong>Job Type:</strong> {{ row1.item.JobType }}<br />
                        <strong>Job Date:</strong> {{ row1.item.JobDate }}<br />
                        <strong>Raised From:</strong> {{ row1.item.RaisedFrom }}<br />
                        <strong>Bill Status:</strong>
                        {{ row1.item.FinalBillingCompletedStatus }}<br />
                        <strong>Bill Type:</strong> {{ row1.item.IsBillingTypeStatus
                        }}<br />
                       
                      </b-col>
                      <b-col>
                        <strong>Client Name:</strong> {{ row1.item.ClientName }}<br />
                        <strong>Sline Name:</strong> {{ row1.item.ShippingLine }}<br />
                        <strong>Por:</strong> {{ row1.item.Por }}<br />
                        <strong>Pol:</strong> {{ row1.item.Pol }}<br />
                        <strong>Pod:</strong> {{ row1.item.Pod }}<br />
                        <strong>Fpod:</strong> {{ row1.item.Fpod }}<br />
                        <strong>MBL NO:</strong> {{ row1.item.MblNo }}<br />
                        <strong>HBL NO:</strong> {{ row1.item.HblNo }}<br />
                        <strong>MBL Date:</strong> {{ row1.item.MblDate }}<br />
                        <strong>MBL Release Date:</strong> {{ row1.item.MblReleaseDate
                        }}<br />
                      </b-col>
                      <b-col>
                        <strong>Add Task:</strong> {{ row1.item.AdditionalTaskStatus
                        }}<br />
                        <strong>Sline:</strong> {{ row1.item.SlinePaymentStatus }}<br />
                        <strong>Manifest:</strong> {{ row1.item.MenifestationStatus
                        }}<br />
                        <strong>Expense:</strong> {{ row1.item.ExpenseStatus }}<br />
                        <strong>Payment Clear:</strong> {{ row1.item.ActiveStatus }}<br />
                        <strong>Payment Remark:</strong> {{ row1.item.EmailRemark }}<br />
                        <b-button
                          style="font-size: 0.675rem"
                          v-if="row1.item.email_contents"
                          size="sm"
                          text="View Mult-Billing"
                          class="m-2"
                          variant="outline-info"
                          @click="
                            showextra_paymentModal(
                              row1.item.allModuleId,
                              row1.item.email_contents,
                              row1.item.doc_link,
                              row1.item,
                              row1.item.JobNo
                            )
                          "
                          ><b v-if="row1.item.is_additional_task == 1">Additional Task</b
                          ><b v-else-if="row1.item.is_expense == 1">Expense Task</b
                          ><b v-else-if="row1.item.is_menifestation == 1"
                            >Manifestation Task</b
                          ><b v-else-if="row1.item.is_slinepayment == 1"
                            >Sline Payment Task</b
                          ></b-button
                        >
                      </b-col>
                      <b-col>
                        <strong>Created By:</strong> {{ row1.item.CreatedByUser }}<br />
                        <strong>Created Date:</strong> {{ row1.item.CreatedDate }}<br />
                        <strong>Cleared By:</strong> {{ row1.item.ClearedByUser }}<br />
                        <strong>Cleared Date:</strong> {{ row1.item.UpdatedDate }}<br />
                        <strong>Payment Close Reason:</strong
                        ><span v-html="row1.item.PaymentCloseReason">{{
                          row1.item.PaymentCloseReason
                        }}</span
                        ><br />
                        <strong>Ass Close Reason:</strong
                        ><span v-html="row1.item.JobCloseReason">{{
                          row1.item.JobCloseReason
                        }}</span>
                      </b-col>
                      <b-col>
                        <div
                          v-if="
                            row1.item.FreightContainers != 'null' ||
                            row1.item.FreightContainers != null ||
                            row1.item.FreightContainers != 'undefined' ||
                            row1.item.FreightContainers != undefined
                          "
                        >
                          <div class="text-left" v-if="row1.item.FreightContainers">
                            <div v-if="row1.item.FreightContainers">
                              <span
                                v-for="(
                                  item1, index
                                ) in row1.item.FreightContainers.split(',')"
                                :key="index"
                              >
                                <h6>
                                  <b-badge variant="light"
                                    >{{ item1 == "" ? "-------" : item1 }}
                                  </b-badge>
                                </h6>
                              </span>
                            </div>
                          </div>
                        </div>
                        <span
                          ><strong>Type :</strong>
                          {{ row1.item.FreightContainersType }}</span
                        ><br />
                        <span><strong>SOB :</strong> {{ row1.item.SOB }}</span
                        ><br />
                        <span><strong>Sys SOB :</strong> {{ row1.item.SysSOB }}</span
                        ><br />
                        <span><strong>SINV NO :</strong></span
                        ><br />
                        <div v-if="row1.item.SINVNO">
                          <span
                            v-for="(item2, index) in row1.item.SINVNO.split(',')"
                            :key="index"
                          >
                            <h6>
                              <b-badge variant="light"
                                >{{ item2 == "" ? "-------" : item2 }}
                              </b-badge>
                            </h6></span
                          >
                        </div>
                        <span v-else>-----------</span><br />
                        <span
                          ><strong>SB NO :</strong>
                          <div v-if="row1.item.SBILLNO">
                            <span
                              v-for="(item2, index) in row1.item.SBILLNO.split(',')"
                              :key="index"
                            >
                              <h6>
                                <b-badge variant="light"
                                  >{{ item2 == "" ? "-------" : item2 }}
                                </b-badge>
                              </h6></span
                            >
                          </div></span
                        ><br />
                        <span
                          ><strong>CUST. SEAL NO :</strong>
                          <div v-if="row1.item.CUST_SEAL_NO">
                            <span
                              v-for="(item2, index) in row1.item.CUST_SEAL_NO.split(',')"
                              :key="index"
                            >
                              <h6>
                                <b-badge variant="light"
                                  >{{ item2 == "" ? "-------" : item2 }}
                                </b-badge>
                              </h6></span
                            >
                          </div></span
                        ><br />
                        <span
                          ><strong>LINE SEAL NO :</strong>
                          <div v-if="row1.item.LINE_SEAL_NO">
                            <span
                              v-for="(item2, index) in row1.item.LINE_SEAL_NO.split(',')"
                              :key="index"
                            >
                              <h6>
                                <b-badge variant="light"
                                  >{{ item2 == "" ? "-------" : item2 }}
                                </b-badge>
                              </h6></span
                            >
                          </div></span
                        ><br />
                        <span
                          ><strong>OE Date :</strong>
                          {{ row1.item.OfFirstPaymentDate }}</span
                        ><br />
                        <span
                          ><strong>MBL Release Date :</strong>
                          {{ row1.item.MblReleaseDate }}</span
                        ><br />
                      </b-col>
                    </b-row>
                  </b-card>
                </template>
              </b-table>
            </div>
            <div>
              <b-pagination
                limit="25"
                align="center"
                v-model="pagination.currentPage"
                :per-page="pagination.perPage"
                :total-rows="totalData"
                @change="onPageChange($event)"
              ></b-pagination>
            </div>
          </div>
        </div>
      </b-card-text>
    </b-card>
    <!-- Additional Extra Payment Modal Start -->
    <b-modal
      id="modal-extra_payment"
      ref="modal-extra_payment"
      title="Extra Payment Details"
      size="lg"
      centered
      no-close-on-esc
      no-close-on-backdrop
      hide-footer
    >
      <h3 v-if="extra_payment_Title">{{ extra_payment_Title }}</h3>
      <span v-html="extra_payment_Arr">{{ extra_payment_Arr }}</span>

      <b v-if="extra_payment_doc.length > 0">
        <u><h4>Supporting Documents</h4></u><br />
        <span
          v-for="(item_doc, index_doc) in extra_payment_doc.split(',')"
          :key="index_doc"
        >
          <a
            href="javascript:void(0)"
            @click="PrintValidity_Doc(item_doc, extra_payment_folder)"
            >View Document - {{ index_doc + 1 }}</a
          ><br />
        </span>
      </b>

      <b-button @click="closeextra_payment" variant="danger" class="pull-right">
        Close</b-button
      >
    </b-modal>
    <!-- Additional Extra Payment Modal End -->
    <b-modal
      id="modal-close-conf"
      ref="modal-close-conf"
      :title="'Reviewed Confirmation'"
      centered
      no-close-on-esc
      no-close-on-backdrop
      hide-footer
    >
      <b-row>
        <b-col cols="12" class="mb-2">
          <label>Remark:</label>
          <b-form-textarea
            :formatter="capitalizeAll"
            rows="5"
            id="name-input"
            v-model="reviewed_remark"
            required
          ></b-form-textarea>
        </b-col>
        <b-col cols="12" class="text-center">
          <b-button @click="closeModalConfirm" variant="danger" size="sm">Close</b-button>
          <b-button
            :disabled="!reviewed_remark"
            variant="success"
            size="sm"
            @click="closeReviewConfirmation"
          >
            Proceed
          </b-button>
        </b-col>
      </b-row>
    </b-modal>

    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop"
    ></md-dialog-alert>

    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="closeReviewConfirmation"
      ref="addPopClose"
    ></md-dialog-confirm>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import CustomLoader from "../common/customLoader.vue";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import { lastVisitPage, globalPermissionStatus } from "../../helper/collection";
import DateRangePicker from "vue2-daterange-picker";
import NodeLockPannelService from "../../services/NodeLockPannelService";
import { ModelListSelect, MultiSelect } from "vue-search-select";
import Multiselect from "vue-multiselect";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant";
import ContaierWebLogSummary from "../common/moduleBasedContaierWebLogSummary.vue";
import DocForm from "../allModuleForm/docLibrary.vue";
import AssignmentSummary from "../common/assignmentSummary.vue";
import InvExpSummary from "../common/moduleBasedInvExpSummary.vue";
import ContainerSummary from "../common/moduleBasedContaierSummary.vue";
import JobWisePaymentsDetails from "../common/jobWisePaymentsDetails.vue";
import RejectInvTallyBillSummary from "../common/moduleBasedRejectInvTallyBillSummary.vue";

export default {
  // Component logic for Tab 1
  beforeMount() {
    lastVisitPage(this.$router.history.current.fullPath);
    console.log(
      "this.$router.history.current.fullPath=>",
      this.$router.history.current.fullPath
    );

    this.$store.dispatch("setCurrentRoute", this.$router.history.current.fullPath);
    // this.getCurrentLastDate();
    this.$store.dispatch(
      "common/setAllUserList",
      JSON.stringify({
        itemCode: "GET_USERLIST_Data",
      })
    );
    this.$store.dispatch(
      "common/setAllClientList",
      JSON.stringify({
        itemCode: "ClientList",
      })
    );
    this.$store.dispatch(
      "common/setAllShippingLineList",
      JSON.stringify({
        itemCode: "ShippingLineList",
      })
    );
    this.$store.dispatch(
      "common/setAllBranchList",
      JSON.stringify({
        filter: "BranchList",
        active: "all",
      })
    );
    if (this.lastVisitPage && this.$sessionsStorage.get("lastVisitPage")) {
      this.fetchLastPage(this.lastVisitPage);
    } else {
      this.getLockPanelDash("Normal", "0", "0", "1", "1");
    }
  },
  mounted() {},
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  beforeDestroy() {},

  destroyed() {},
  data() {
    return {
      isClientKycDash:
        this.$route.path == this.$router.history.current.fullPath ? true : false,
      docURL: URL_BASE_DOC,
      selectDateFormat,
      lastVisitPage: this.$sessionsStorage.get("lastVisitPage"),
      ExcelBtnName: "Export As Excel",
      visible: false,
      getLockPanel: [],
      totalData: 0,

      billedStatusList: [
        { value: "", text: "All" },
        { value: "Billed", text: "Billed" },
        { value: "Not to be Billed", text: "Not to be Billed" },
        { value: "Pending/Not Cleared", text: "Pending/Not Cleared" },
      ],
      LockDashFields: [
        {
          key: "SN",
          mainkey: "SN",
          label: "SN.",
          sortable: true,
          sortDirection: "ASC",
          table: "A.",
        },

        {
          key: "JobNo",
          mainkey: "JobNo",
          label: "Job Details",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        // {
        //   key: "ClientName",
        //   mainkey: "ClientName",
        //   label: "Client/Sline",
        //   sortable: true,
        //   sortDirection: "ASC",
        //   table: "C.",
        // },
        {
          key: "TallyExpNo",
          mainkey: "TallyExpNo",
          label: "Expense Det. From Tally",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "TallyInvNo",
          mainkey: "TallyInvNo",
          label: "Billing Det. From Tally",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        // {
        //   key: "FreightContainers",
        //   mainkey: "FreightContainers",
        //   label: "Container Det.",
        //   sortable: true,
        //   sortDirection: "ASC",
        //   table: "C.",
        // },
        // {
        //   key: "SOB",
        //   mainkey: "SOB",
        //   label: "SOB Details",
        //   sortable: true,
        //   sortDirection: "ASC",
        //   table: "C.",
        // },
        {
          key: "EmailRemark",
          mainkey: "EmailRemark",
          label: "Panel Det.",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },

        // {
        //   key: "doc_link",
        //   mainkey: "doc_link",
        //   label: "Document",
        //   sortable: true,
        //   sortDirection: "ASC",
        //   table: "C.",
        // },
        {
          key: "FirstUnlockUser",
          mainkey: "FirstUnlockUser",
          label: "Review",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "CreatedDate",
          mainkey: "CreatedDate",
          label: "Action",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
      ],

      pagination: {
        currentPage: 1,
        perPage: 50,
        pageOptions: [5, 10, 15],
      },
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      paymentClearType: [
        {
          inv: "0",
          int: "Clear",
        },
        {
          inv: "1",
          int: "Pending",
        },
        {
          inv: "",
          int: "All",
        },
      ],
      StatusList: [
        {
          DVal: "0",
          DText: "In-Active",
        },
        {
          DVal: "1",
          DText: "Active",
        },
        {
          DVal: "",
          DText: "All",
        },
      ],
      BillingTypeStatusList: [
        {
          inv: "1",
          int: "Local Billing",
        },
        {
          inv: "2",
          int: "Overseas Billing",
        },
        {
          inv: "",
          int: "All",
        },
      ],
      SOBStatusList: [
        {
          inv: "1",
          int: "Sailed",
        },
        {
          inv: "2",
          int: "Not Sailed",
        },
        {
          inv: "",
          int: "All",
        },
      ],
      BillingStatusList: [
        {
          inv: "1",
          int: "Completed",
        },
        {
          inv: "0",
          int: "Pending",
        },
        {
          inv: "",
          int: "All",
        },
      ],
      paymentType: [
        {
          pTypeVal: "1",
          pTypeText: "Yes",
        },
        {
          pTypeVal: "0",
          pTypeText: "No",
        },
        {
          pTypeVal: "",
          pTypeText: "All",
        },
      ],
      Filter: {
        // statusFilter: "",
        reviewedFilter: '0',
        reviewedByFilter: "",
        BilledRemark: "Pending/Not Cleared",
        MblNoFilter: "",
        HblNoFilter: "",
        ContainerNoFilter: "",
        JobNoFilter: "",
        remarkFilter: "",
        additionalTaskFilter: "",
        expenseFilter: "",
        menifestationFilter: "",
        SlineFilter: "",
        finalBillingStatusFilter: "",
        billingTypeFilter: "",
        clearStatusFilter: "1",
        clientFilter: "",
        slineIdFilter: "",
        commonFilter: "",
        createdByFilter: "",
        clearedByFilter: "",
        branchFilter: "",
        createdAtRange: {
          startDate: "",
          endDate: "",
        },
        startDate: "",
        endDate: "",
      },
      //Added By Priyanshu Singh Multi Select Start
      isCheckAll: false,
      AllModule_ids: [],
      AllPayment_ids: [],
      selectedAllModule_ids: "",
      selectedPayment_ids: "",

      openLeft: "left",
      showCal: false,
      startDate: "2017-09-05",
      endDate: "2017-09-15",
      createdAtRange: {
        startDate: "",
        endDate: "",
      },
      locale: {
        direction: "ltr",
        format: "mm/dd/yyyy",
        separator: " - ",
        applyLabel: "Apply",
        cancelLabel: "Cancel",
        weekLabel: "W",
        customRangeLabel: "Custom Range",
        daysOfWeek: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        monthNames: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
        firstDay: 0,
      },
      alert: {
        content: "Are you sure you want to delete ..!",
        ok: "ok",
      },
      value1: [new Date(2019, 9, 8), new Date(2019, 9, 19)],
      value2: [],
      langType: {
        pickers: ["Today", "Yesterday", "This Month", "This Year"],
      },
      time: "",
      date: "",
      week: ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"],

      langEnq: {
        pickers: ["", "", "previous 7 days", "previous 30 days"],
      },
      isLoading: false,
      extra_payment_Title: "",
      extra_payment_Arr: "",
      extra_payment_doc: "",
      extra_payment_folder: "",
      extra_payment_allModuleId: "",
      extra_payment_JobNo: "",
      close_type: "Billing",
      PaymentClearTIT: "",
      PaymentClearMsg: "",
      generateExcel: "0",
      reviewed_remark:'',
    };
  },

  components: {
    CustomLoader,
    DatePicker,
    ModelListSelect,
    DateRangePicker,

    MultiSelect,
    Multiselect,

    ContaierWebLogSummary,
    DocForm,
    AssignmentSummary,
    InvExpSummary,
    ContainerSummary,
    RejectInvTallyBillSummary,
    JobWisePaymentsDetails,
  },
  computed: {},
  watch: {
    "$route.path": {
      handler(newPath) {
        this.isClientKycDash = newPath === this.$router.history.current.fullPath;
      },
      immediate: true,
    },
  },
  methods: {
    SelectAll: function () {
      console.log("this.getLockPanel=>", this.getLockPanel);
      this.isCheckAll = !this.isCheckAll;
      this.AllModule_ids = [];
      this.AllClient_ids = [];
      if (this.isCheckAll) {
        // Check all
        for (var key in this.getLockPanel) {
          if (
            this.getLockPanel[key].isActive != 0 &&
            this.getLockPanel[key].is_reviewed == 0
          ) {
            this.AllModule_ids.push(this.getLockPanel[key].allModuleId);
            this.AllPayment_ids.push(this.getLockPanel[key].extrapayment_id);
          }
        }
        console.log("this.AllModule_ids=>", this.AllModule_ids);
        console.log("this.AllPayment_ids=>", this.AllPayment_ids);
      }
    },
    updateSelectAll: function (e, item) {
      console.log("ids", e);
      console.log("ids", item);
      if (this.AllModule_ids.length == this.getLockPanel.length) {
        this.isCheckAll = true;
      } else {
        this.isCheckAll = false;
      }

      const istrue = this.AllModule_ids.includes(item.allModuleId);
      if (istrue == true) {
        this.AllPayment_ids.push(item.extrapayment_id);
      } else {
        const index = this.AllPayment_ids.indexOf(item.extrapayment_id);
        this.AllPayment_ids.splice(index, 1);
      }

      console.log("this.AllModule_ids=>", this.AllModule_ids);
      console.log("this.AllPayment_ids=>", this.AllPayment_ids);
    },
    ProceedReview() {
      // this.alert.content =
      //   "Payment has been successfully cleared and reviewed by the Account Team. Please review the payment records to ensure everything is accurate and up to date.";
      // this.$refs["addPopClose"].open();
      this.$refs["modal-close-conf"].show();
    },
    closeModalConfirm() {
      this.reviewed_remark = '';
      this.$refs['modal-close-conf'].hide()
    },
    closeReviewConfirmation() {
      console.log(
        "this.AllModule_ids.length=>",
        this.AllModule_ids.length,
        this.AllPayment_ids.length
      );
      if (this.AllModule_ids.length > 0 && this.AllPayment_ids.length > 0 && this.reviewed_remark) {
        let payload = {
          AllPayment_ids: this.AllPayment_ids,
          AllModule_ids: this.AllModule_ids,
          is_reviewed: 1,
          reviewed_remark:this.reviewed_remark,
        };
        NodeLockPannelService.setRevieweStatus(payload)
          .then((response) => {
            const { data, status, message } = response;
            console.log("data PS=>", data.data);
            if (status == 200 && data) {
              this.alert.content = message;
              this.$refs["addPop"].open();
              this.$refs["modal-close-conf"].hide();
              this.getLockPanelDash("Normal", "0", "0", "1", "1");
            }
            this.isLoading = false;
          })
          .catch((error) => {
            console.log("Catch on getLockPanel Error: ", error);
          });
      } else {
        this.alert.content = "Please Select Atleast One Payment";
        this.$refs["addPop"].open();
      }
    },
    clearFilter() {
      this.Filter = {
        // statusFilter: "",
        reviewedFilter: '0',
        reviewedByFilter: "",
        BilledRemark: "Pending/Not Cleared",
        MblNoFilter: "",
        HblNoFilter: "",
        ContainerNoFilter: "",
        JobNoFilter: "",
        remarkFilter: "",
        additionalTaskFilter: "",
        expenseFilter: "",
        menifestationFilter: "",
        SlineFilter: "",
        finalBillingStatusFilter: "",
        billingTypeFilter: "",
        clearStatusFilter: "1",
        clientFilter: "",
        slineIdFilter: "",
        commonFilter: "",
        createdByFilter: "",
        clearedByFilter: "",
        branchFilter: "",
        createdAtRange: {
          startDate: "",
          endDate: "",
        },
        startDate: "",
        endDate: "",
      };
      this.getLockPanelDash("Normal", "0", "0", "1", "1");
    },
    getCurrentLastDate() {
      var today = new Date();
      var firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
      var lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);

      var firstDay_dd = String(firstDay.getDate()).padStart(2, "0");
      var firstDay_mm = String(firstDay.getMonth() + 1).padStart(2, "0"); //January is 0!
      var firstDay_yyyy = firstDay.getFullYear();

      var lastDay_dd = String(lastDay.getDate()).padStart(2, "0");
      var lastDay_mm = String(lastDay.getMonth() + 1).padStart(2, "0"); //January is 0!
      var lastDay_yyyy = lastDay.getFullYear();

      firstDay = firstDay_yyyy + "/" + firstDay_mm + "/" + firstDay_dd; //2018-06-01
      lastDay = lastDay_yyyy + "/" + lastDay_mm + "/" + lastDay_dd; //2018-06-01

      var dd = String(today.getDate()).padStart(2, "0");
      var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      var yyyy = today.getFullYear();
      today = yyyy + "/" + mm + "/" + dd; //2018-06-01
      this.startDate = today;
      this.Filter.createdAtRange = {
        startDate: firstDay,
        endDate: lastDay,
      };
    },

    PrintValidity_Doc(validity_doc, JobNo) {
      window.open(
        `${this.docURL}/ASSIGNMENT_UPLOADS/${JobNo.replaceAll("/", "_")}/` + validity_doc
      );
    },
    showextra_paymentModal(allModuleId, email_contents, doc_link, item, mainSalesSeries) {
      this.extra_payment_Title = "";
      this.extra_payment_Arr = "";
      this.extra_payment_doc = "";
      this.extra_payment_folder = "";
      this.extra_payment_folder = mainSalesSeries;

      if (item.is_additional_task == 1) {
        this.extra_payment_Title = "Additional Payment Task";
      } else if (item.is_expense == 1) {
        this.extra_payment_Title = "Expense Payment Task";
      } else if (item.is_menifestation == 1) {
        this.extra_payment_Title = "Manifestation Payment Task";
      } else if (item.is_slinepayment == 1) {
        this.extra_payment_Title = "Sline Payment Task";
      }
      this.extra_payment_Arr = email_contents;
      this.extra_payment_doc = doc_link;
      this.$refs["modal-extra_payment"].show();
    },
    closeextra_payment() {
      (this.extra_payment_Title = ""), this.$refs["modal-extra_payment"].hide();
    },
    getLockPanelDash(type, filterIdD, CURRENT, SEARCH, pageNumber) {
      this.getLockPanel = [];
      let payload = {};
      if (type == "Normal") {
        this.isLoading = true;
      }
      payload = {
        itemCode: "getLockPanel",
        type: type,
        DCfilterId: filterIdD,
        searchVal: this.filter,
        DCfilterId: filterIdD,
        fromSearch: SEARCH,
        // currentPage: CURRENT,
        currentPage: this.pagination.currentPage,
        page: this.pagination.currentPage,
        perPage: this.pagination.perPage,
        pageSize: this.pagination.perPage,
        filter: this.Filter,
        generateExcel: this.generateExcel,
      };
      // Set responseType to 'blob' if generating Excel
      const config = this.generateExcel == "1" ? { responseType: "blob" } : {};
      NodeLockPannelService.getAllLockPannelList(payload, config)
        .then((response) => {
          const { data, status, statusText } = response;
          console.log("data PS=>", data.data);
          if (status == 200 && data) {
            if (this.generateExcel == "1") {
              // Handle file download
              // const url = window.URL.createObjectURL(new Blob([data]));

              const blob = new Blob([data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              });
              const url = window.URL.createObjectURL(blob);
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", "LockPanelData.xlsx"); // Specify the file name
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);

              this.ExcelBtnName = "Export As Excel";
              this.generateExcel = "0";
              this.getLockPanelDash("Normal", "0", "0", "1", "1");
            } else {
              if (data.data.length > 0) {
                this.totalData = data.pagination.total;
                this.getLockPanel = data.data;
              }
            }
          }
          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on getLockPanel Error: ", error);
        });
    },
    onFiltered(filtered) {
      this.totalRows = filtered.length;
      this.pagination.currentPage = 1;
    },
    clearTimeout() {},
    goBack() {
      window.history.go(-1);
    },

    debounceSearch(event) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.getLockPanelDash("Normal", "0", "0", "1", "1");
      }, 1000);
    },
    getReports(id, btnName) {
      this.isLoading = true;
      this.generateExcel = "1";
      this.ExcelBtnName = "Downloading Please Wait .....";
      this.getLockPanelDash("Excell", "0", "0", "1", "1");
    },
    fetchLastPage(event) {
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = parseInt(event) * this.pagination.perPage - this.pagination.perPage;
      }
      this.getLockPanelDash("Normal", "0", CURRENT, "2", event);
    },
    onPageChange: function (event) {
      console.log("event=>", event);
      this.pagination.currentPage = event;
      this.$sessionsStorage.set("lastVisitPage", event);
      this.$sessionsStorage.set("oldRoute", this.$router.history.current.fullPath);
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = event * this.pagination.perPage - this.pagination.perPage;
      }
      this.getLockPanelDash("Normal", "0", CURRENT, "2", event);
    },
  },
};
</script>



// WEBPACK FOOTER //
// lockPannelDash.vue?e1fb0be0